var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { parseTimeFull, globalTimeTicker } from "../../helpers";
/**
 * AutoTimer
 * @param {time} Number time in milliseconds
 */
var AutoTimer = /** @class */ (function (_super) {
    __extends(AutoTimer, _super);
    function AutoTimer(props) {
        var _this = _super.call(this, props) || this;
        _this.time = _this.props.time;
        _this.tock = globalTimeTicker;
        return _this;
    }
    AutoTimer.prototype.tick = function () { return this.time += globalTimeTicker.interval; };
    AutoTimer.prototype.render = function () {
        this.tock.tick;
        return React.createElement("span", null, parseTimeFull(this.tick()));
    };
    AutoTimer = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], AutoTimer);
    return AutoTimer;
}(React.Component));
export { AutoTimer };
//# sourceMappingURL=AutoTimer.js.map